import { reactive } from 'vue';

export const tooltipState = reactive({
    visible: false,
    triggerEl: null,
    content: '',
    render: null,
    alignment: 'left',
    verticalAlignment: 'top',
    offset: 0,
    tooltipClass: '',
    additionalTooltipClass: '',
});

export function showTooltip(opts) {
    tooltipState.visible = true;
    tooltipState.triggerEl = opts.triggerEl ?? null;
    tooltipState.content = opts.content ?? '';
    tooltipState.render = opts.render ?? null;
    tooltipState.alignment = opts.alignment ?? 'left';
    tooltipState.verticalAlignment = opts.verticalAlignment ?? 'top';
    tooltipState.offset = opts.offset ?? 0;
    tooltipState.tooltipClass = opts.tooltipClass ?? '';
    tooltipState.additionalTooltipClass = opts.additionalTooltipClass ?? '';
}

export function hideTooltip(triggerEl) {
    if (!triggerEl || tooltipState.triggerEl === triggerEl) {
        tooltipState.visible = false;
        tooltipState.triggerEl = null;
        tooltipState.render = null;
    }
}
